"use strict";var e=require("react/jsx-runtime");exports.default=()=>e.jsx("div",{children:"404 Not found"});